import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=f01aa84a"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js"
import style0 from "./LayoutHorizontal.vue?vue&type=style&index=0&id=f01aa84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports